module.exports = __webpack_public_path__ + "static/img/vision_track_gray.1ffa051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vision_track_gray.png
// module id = OR2e
// module chunks = 1